<ion-header class="extendido">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{'Fotos da Reunião' | translate}}</ion-title>
  </ion-buttons>
</ion-header>

<ion-content>
  <div class="div-padding">
    <img [src]="imageList.url | image:' '" />

    <ion-grid>
      <ion-row class="border-row">
        <ion-col>
          <div>
            <p class="titulo">{{imageList.nome}}</p>

            <span class="data">
              {{ imageList.updated_at | dateFormat:'dd MMM yyyy' }}
            </span>
          </div>
        </ion-col>
      </ion-row>

      <ion-row class="ion-justify-content-center">
        <ion-col size="9">
          <ion-button
            expand="block"
            class="btn-danger"
            (click)="removerFoto(imageList.id)"
          >
            <i class="fa-regular fa-trash-can"></i>

            {{'Remover' | translate}}
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</ion-content>
